import React from 'react';
import ProcessSection from '../components/ProcessSection';

const Process = () => {
  return (
    <div style={{ paddingTop: 'calc(var(--nav-height) + 40px)', paddingBottom: '80px' }}>
      <div className="container">
        <div style={{ textAlign: 'center', maxWidth: '760px', margin: '0 auto 40px' }}>
          <span className="section-badge">MANUFACTURING BLUEPRINT</span>
          <h1 style={{ fontSize: 'clamp(36px, 5vw, 60px)', fontFamily: 'var(--font-heading)', fontWeight: 900, textTransform: 'uppercase', marginBottom: '16px' }}>
            OUR <span className="gradient-text">PROCESS</span>
          </h1>
          <p style={{ fontSize: '18px', color: 'var(--text-muted)', lineHeight: '1.6' }}>
            Explore every stage of our production cycle — from raw indigo fabric selection to export-ready polybag and carton packaging.
          </p>
        </div>
      </div>

      <ProcessSection />
    </div>
  );
};

export default Process;
